import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logout } from '../../auth/authActions';
import './custom.css';
import ModalHeader from '../modal/modal';
import ModalSeleciona from '../modal/modalSeleciona';
import { Redirect } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import manual from '../artifact/Manual_Central_Online_SSAT.pdf';
import moment from 'moment';

// Imports do novo sistema de notificações - SISTEMA COMPLETO
import { BellNotification } from '../../notifications';
import TicketSuporteForm from '../../ticket_suporte/ticketSuporteForm';

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      show: false,
      body: null,
      auxGrup: null,
      auxCont: null,
      auxGrupD: '',
      auxContD: '',
      auxNumCont: '',
      Grup: 'Selecionar',
      Cont: 'Selecionar',
      GrupD: 'Selecionar Grupo Físico',
      ContD: 'Selecionar Controlador',
      numCont: null,
      contLat: null,
      contLong: null,
      anel: 1,
      redirecionarControlador: '',
      loop: 0,
      redirect: false,
      showTicketModal: false,
      selectedErrorForTicket: null,
    };

    this.clickOk = this.clickOk.bind(this);
    this.modalSelecionaShow = this.modalSelecionaShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.changeControlador = this.changeControlador.bind(this);
    this.changeGrupoFisico = this.changeGrupoFisico.bind(this);
    this.validaSelecao = this.validaSelecao.bind(this);
    this.validaSelecaoOK = this.validaSelecaoOK.bind(this);
    this.handleShowTicketModal = this.handleShowTicketModal.bind(this);
    this.handleCloseTicketModal = this.handleCloseTicketModal.bind(this);
  }

  handleShowTicketModal(error) {
    this.setState({ showTicketModal: true, selectedErrorForTicket: error });
  }

  handleCloseTicketModal() {
    this.setState({ showTicketModal: false, selectedErrorForTicket: null });
  }

  clickOpen() {
    this.setState({ open: !this.state.open });
  }

  changeClose() {
    this.setState({ open: false });
  }

  handleClose() {
    if (this.validaSelecao()) {
      this.setState({ show: false });
    }
  }

  changeGrupoFisico(event) {
    let index = event.nativeEvent.target.selectedIndex;

    this.setState({ auxGrup: event.target.value });
    this.setState({ auxGrupD: event.nativeEvent.target[index].text });

    this.setState({ auxCont: null });
    this.setState({ auxContD: 'Selecionar' });
    this.setState({ auxNumCont: 'Selecionar' });
  }

  changeControlador(event, latLon, anel) {
    if (event.target.value !== 'Selecionar') {
      let index = event.target.selectedIndex;
      let contDescricao = event.target[index].text;
      let numeroCont = contDescricao.split('-');
      let latLonSplit = latLon.split('|');

      this.setState({ auxCont: event.target.value });
      this.setState({ auxContD: event.nativeEvent.target[index].text });
      this.setState({ auxNumCont: parseInt(numeroCont) });
      this.setState({ contLat: latLonSplit[0] });
      this.setState({ contLong: latLonSplit[1] });
      this.setState({ anel: anel });
    }
  }

  modalSelecionaShow() {
    var _cfg = localStorage.getItem('_cfg');

    if (_cfg !== null) {
      _cfg = JSON.parse(_cfg);

      this.setState({ Grup: _cfg.grupo });
      this.setState({ Cont: _cfg.cont });
      this.setState({ GrupD: _cfg.grupoDes });
      this.setState({ ContD: _cfg.contDes });

      this.setState({ auxGrup: this.state.Grup });
      this.setState({ auxCont: this.state.Cont });
      this.setState({ auxGrupD: this.state.GrupD });
      this.setState({ auxContD: this.state.ContD });
    }

    this.setState({
      body: (
        <div>
          <ModalSeleciona
            grupoVal={this.state.Grup}
            controladorVal={this.state.Cont}
            onChangeGrupoFisico={this.changeGrupoFisico}
            onChangeControlador={this.changeControlador}
          />
        </div>
      ),
    });

    this.setState({ show: true });
  }

  validaSelecao() {
    let grupochildCount = window.$('#seleciona_grupo_fisico')[0].childElementCount;
    let contchildCount = window.$('#seleciona_controlador')[0].childElementCount;

    if (grupochildCount > 1 && ((this.state.Grup === null || this.state.Grup === undefined) || this.state.Grup === 'Selecionar')) {
      if (this.state.auxGrup === 'Selecionar' || (this.state.auxGrup === null || this.state.auxGrup === undefined)) {
        toastr.warning('Alerta', 'Selecione um "Grupo Físico".');
        return false;
      }
    }
    if (contchildCount > 1 && this.state.Cont === 'Selecionar') {
      if (this.state.auxCont === 'Selecionar' || (this.state.auxCont === null || this.state.auxCont === undefined)) {
        toastr.warning('Alerta', 'Selecione um "Controlador".');
        return false;
      }
    }

    return true;
  }

  validaSelecaoOK() {
    if (this.validaSelecao()) {
      if (this.state.auxGrup === 'Selecionar' || (this.state.auxGrup === null || this.state.auxGrup === undefined)) {
        toastr.warning('Alerta', 'Selecione um "Grupo Físico".');
        return false;
      }

      if (this.state.auxCont === 'Selecionar' || (this.state.auxCont === null || this.state.auxCont === undefined)) {
        let contchildCount = window.$('#seleciona_controlador')[0].childElementCount;
        if (contchildCount > 1) {
          toastr.warning('Alerta', 'Selecione um "Controlador".');
          return false;
        }
      }

      return true;
    }
    return false;
  }

  clickOk(history) {
    let _cfg = {};
    let _confAtual = localStorage.getItem('_cfg');
    _confAtual = JSON.parse(_confAtual);

    if (this.validaSelecaoOK()) {
      if (this.state.auxCont === null && this.state.auxGrup !== this.state.Grup) {
        _cfg = {
          grupo: this.state.auxGrup,
          grupoDes: this.state.auxGrupD,
          cont: 'Selecionar',
          contDes: 'Selecionar Controlador',
          numCont: null,
          contLat: this.state.contLat,
          contLong: this.state.contLong,
          anel: this.state.anel,
          event: 0,
        };

        localStorage.setItem('_cfg', JSON.stringify(_cfg));

        this.setState({ Cont: 'Selecionar' });
        this.setState({ ContD: 'Selecionar Controlador' });
        this.setState({ numCont: null });

        this.setState({ Grup: this.state.auxGrup });
        this.setState({ GrupD: this.state.auxGrupD });

        this.setState({ show: false });
        this.setState({ redirect: true });
      } else {
        if (this.state.auxCont === null) {
          _cfg = {
            grupo: this.state.auxGrup,
            grupoDes: this.state.auxGrupD,
            cont: this.state.Cont,
            contDes: this.state.ContD,
            numCont: this.state.numCont,
            contLat: this.state.contLat,
            contLong: this.state.contLong,
            anel: this.state.anel,
            event: 0,
          };
        } else {
          let descCont = this.state.auxContD;

          if (_confAtual) {
            descCont = _confAtual.event === 2 ? _confAtual.contDes : this.state.auxContD;
            descCont =
              _confAtual.event === 1 && parseInt(_confAtual.cont) === parseInt(this.state.auxCont)
                ? _confAtual.contDes
                : descCont;
          }

          _cfg = {
            grupo: this.state.auxGrup,
            grupoDes: this.state.auxGrupD,
            cont: this.state.auxCont,
            contDes: descCont,
            numCont: this.state.auxNumCont,
            contLat: this.state.contLat,
            contLong: this.state.contLong,
            anel: this.state.anel,
            event: 0,
          };

          this.setState({ Cont: this.state.auxCont });
          this.setState({ ContD: descCont });
          this.setState({ numCont: this.state.auxNumCont });
        }

        localStorage.setItem('_cfg', JSON.stringify(_cfg));

        this.setState({ Grup: this.state.auxGrup });
        this.setState({ GrupD: this.state.auxGrupD });

        this.setState({ show: false });
        this.setState({ redirect: true });
      }
    }
  }

  render() {
    if (this.state.redirect === true) {
      this.setState({ redirect: false });
      return <Redirect to="/cadcontrolador" />;
    }

    const { name, email } = this.props.user;

    let nomeIniciais = name.split(' ');
    if (nomeIniciais.length > 1) {
      nomeIniciais = `${nomeIniciais[0][0]}${nomeIniciais[1][0]}`;
    } else {
      nomeIniciais = `${nomeIniciais[0][0]}${nomeIniciais[0][1]}`;
    }

    // Preparar dados para o formulário de ticket
    const { selectedErrorForTicket } = this.state;
    let initialTicketData = null;
    if (selectedErrorForTicket) {
      initialTicketData = {
        titulo: `Erro no Controlador ${selectedErrorForTicket.numero_controlador}`,
        descricao: `Mensagem de Erro: ${selectedErrorForTicket.mensagem}\n\nDetalhes:\n- Data: ${moment(
          selectedErrorForTicket.data_erro,
        ).format('DD/MM/YYYY')}\n- Hora: ${selectedErrorForTicket.hora_erro}\n- Controlador: ${
          selectedErrorForTicket.numero_controlador
        }\n- Grupo Físico: ${selectedErrorForTicket.grupo_fisico_id}`,
        grupo_fisico_id: selectedErrorForTicket.grupo_fisico_id,
        numero_controlador: selectedErrorForTicket.numero_controlador,
        controlador_erro_id: selectedErrorForTicket.id_erro || selectedErrorForTicket.id,
        isFromError: true,
        controlador_id: '',
      };
    }

    return (
      <div className="navbar-custom-menu">
        <ul className="nav navbar-nav">
          {/* Novo sistema de notificações - SISTEMA COMPLETO */}
          <BellNotification className="dropdown user user-menu" />

          <li className={`dropdown user user-menu`}>
            <a
              href={manual}
              id="downloadManual"
              target="_blank"
              rel="noopener noreferrer"
              className="dropdown-toggle a_button"
              aria-expanded={this.state.open ? 'true' : 'false'}
            >
              <i className={'fa fa-download'} />
              <span className="hidden-xs">Manual</span> <br />
            </a>
          </li>

          <li className={`dropdown user user-menu`} style={{ display: 'none' }}>
            <a
              href="/"
              id="selGrupoFisicoNavBar"
              className="dropdown-toggle a_button"
              onClick={this.modalSelecionaShow}
              aria-expanded={this.state.open ? 'true' : 'false'}
            >
              <i className={'fa fa-server'} />
              <span className="hidden-xs">{this.state.GrupD}</span> <br />
            </a>
          </li>

          <li className={`dropdown user user-menu`} style={{ display: 'none' }}>
            <a
              href="/"
              id="selControladorNavBar"
              className="dropdown-toggle a_button"
              onClick={this.modalSelecionaShow}
              aria-expanded={this.state.open ? 'true' : 'false'}
            >
              <i className={'fa fa-hdd'} />
              <span className="hidden-xs">{this.state.ContD}</span> <br />
            </a>
          </li>

          <li
            onMouseLeave={() => this.changeClose()}
            className={`dropdown user user-menu ${this.state.open ? 'open' : ''}`}
          >
            <a
              href="/"
              onMouseEnter={() => this.clickOpen()}
              aria-expanded={this.state.open ? 'true' : 'false'}
              className="dropdown-toggle a_button"
              data-toggle="dropdown"
            >
              <i className={'fa fa-user'} />
              <i className="fa fa-caret-down pull-right" />
            </a>
            <ul className="dropdown-menu dropdown_menu">
              <li className="user-header">
                <p>
                  {name}
                  <small>{email}</small>
                </p>
              </li>
              <li className="user-footer">
                <div className="pull-right">
                  <button onClick={this.props.logout} className="btn btn-default btn-sm">
                    <i className={'fa fa-sign-out-alt'} />
                    <span className="hidden-xs"> Sair</span>
                  </button>
                </div>
              </li>
            </ul>
          </li>
        </ul>

        {this.state.redirecionarControlador}

        <ModalHeader title="Selecionar" show={this.state.show} handleClose={this.handleClose} clickOk={this.clickOk}>
          {this.state.body}
        </ModalHeader>

        {/* Modal de ticket se necessário */}
        {this.props.config && this.props.config.modulo_tickets && this.state.showTicketModal && (
          <TicketSuporteForm
            show={this.state.showTicketModal}
            onHide={this.handleCloseTicketModal}
            ticket={initialTicketData}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({ user: state.auth.user, config: state.auth.config });
const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Navbar);